import React from 'react';
import '../../styles/WelcomePage.css';

const WelcomePage = () => {
    return (
        <div className="welcome-page-container-internal">
            <h1 className="welcome-page-title">Welcome to Newcent Bank System</h1>
            <p className="welcome-page-description">
                Here, you can manage your finances and access a range of banking services.
            </p>
            <p className="welcome-page-description">
                Explore the various features and functionalities available to you:
            </p>
            <ul className="welcome-page-list">
                <li>View your account balances and transaction history</li>
                <li>Transfer funds between your accounts</li>
                <li>Access brokerage services</li>
            </ul>
            <p className="welcome-page-description">
                If you have any questions or need assistance, our customer support team is here to help:
            </p>
            <a href="mailto:support@newcent.ch">support@newcent.ch</a>
        </div>
    );
};

export default WelcomePage;
